import React, { createRef, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import AGFunction from '../components/AGFunction';
import ComFunction from '../components/ComFunction';
import EntryBase from '../components/EntryBase';
import EntryGridAr from '../components/EntryGridAr';
import EntryLayout from '../components/EntryLayout';
import EntryRemarks from '../components/EntryRemarks';
import EntrySetting from '../components/EntrySetting';
import MasterBase from '../components/MasterLayout';
import {
    DeepCopy,
    getcontroller,
    getformid,
    getglobaldata,
    getsubkey,
    getWindowDimensions,
    initializedata,
    isEnabled,
    isEmpty,
    Loadstorage,
    setglobaldata,
} from '../modules/appLibrary';
import { changestatus, entrytriggercall, setgridlist } from '../modules/formstore';
import { addentrylayout, setentrylayout, setentrypanel, setentrystartup } from '../modules/toolpanelstore';

const ComFunc = React.forwardRef(ComFunction);
const AGFunc = React.forwardRef(AGFunction);
const invoiceKeyFields = [
    'IVD_INVOICEKBN',
    'IVD_INVOICECD',
    'IVD_INVOICESUB',
    'IVD_INVOICENO',
    'IVD_INVOICEEDA',
];

function invoiceKeyValue(data, field, fallback = '') {
    const value = data?.[field];
    return value === undefined || value === null || String(value).trim() === ''
        ? fallback
        : String(value).trim();
}

function buildInvoiceIdentity(data) {
    const values = [
        invoiceKeyValue(data, 'IVD_INVOICEKBN', '1'),
        invoiceKeyValue(data, 'IVD_INVOICECD'),
        invoiceKeyValue(data, 'IVD_INVOICESUB', '00000'),
        invoiceKeyValue(data, 'IVD_INVOICENO'),
        invoiceKeyValue(data, 'IVD_INVOICEEDA'),
    ];
    return values[1] === '' || values[3] === '' || values[4] === '' ? '' : values.join('|');
}

function parseInvoiceIdentity(identity) {
    const values = String(identity ?? '').split('|');
    if (values.length !== invoiceKeyFields.length) return {};

    return invoiceKeyFields.reduce((result, field, index) => {
        result[field] = values[index];
        return result;
    }, {});
}

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none',
}));

export const InvoiceIn = props => {
    const panelsdef = [];
    const G_id = { BASE: '0', NB: 'nb' };
    const formid = getformid('InvoiceIn', props.location.search);
    const controller = getcontroller('InvoiceIn', props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const gridlist = useSelector(state => state.form.gridlist);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const fnc = useRef();
    const AGRef = useRef();
    const baseRef = useRef();
    const EntrybodyRef = useRef();
    const entrydataRef = useRef(null);
    const locationstate = useRef(null);
    const transinfo = useRef(null);
    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    const [panel, setpanel] = useState(panelsdef);
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState([]);
    const [primarykeys, setprimarykeys] = useState([]);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [edittingcode, setedittingcode] = useState('');
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [, setUpdate] = useState(false);

    const actionurl = {
        update: 'Forms/Update',
        getlist: 'InvoiceIn/GetListData',
    };

    const entryMenuActionUrl = {
        invoiceFix: 'InvoiceIn/FixInvoice',
        blFix: 'InvoiceIn/FixBlPlan',
        invoiceCover: 'ExportInvoiceReport/Generate',
    };

    const navmenu = [
        { status: 'VIEW', menuid: 'excel', icon: 'file_download', label: 'Excel', title: '現在のシート内容をExcelに出力します' },
        { status: 'VIEW', menuid: 'sep' },
        { status: 'VIEW', menuid: 'invoice-cover', icon: 'print', label: 'INVOICE印刷' },
        { status: 'ENTRY FORM', menuid: 'invoice-confirm', icon: 'check', label: '確定ボタン(Invoice)' },
        { status: 'ENTRY FORM', menuid: 'bl-confirm', icon: 'check', label: '確定ボタン(B/L予定)' },
        { status: 'ENTRY FORM', menuid: 'sep' },
        { status: 'ENTRY FORM', menuid: 'invoice-cover', icon: 'print', label: 'INVOICE印刷' },
    ];

    const suppressaction = [
        { type: '0', action: 'UPDATE' },
        { type: '0', action: 'INSERT' },
        { type: '0', action: 'NEW FORM' },
        { type: '1', action: 'INSERT' },
        { type: '1', action: 'NEW FORM' },
        { type: '1', action: 'ENTRY FORM' },
    ];

    function rerender() {
        setUpdate(current => !current);
    }

    function gridIndex(panelInfo) {
        const localGrid = typeof panelInfo === 'object'
            ? gridlist.find(item => item.id === panelInfo.id && (isEmpty(panelInfo.type) || item.type === panelInfo.type))
            : gridlist.find(item => item.id === panelInfo);
        if (!isEmpty(localGrid)) return localGrid.index;
        if (isEmpty(fnc.current)) return -1;
        return fnc.current.gridindex(panelInfo);
    }

    function SetGridData(panelInfo, data) {
        const index = gridIndex(panelInfo);
        if (index === -1 || isEmpty(griddataRefs.current[index])) return;
        griddataRefs.current[index].current = data;
    }

    function GridData(panelInfo) {
        const index = gridIndex(panelInfo);
        if (index === -1 || isEmpty(griddataRefs.current[index])) return [];
        return griddataRefs.current[index].current;
    }

    function SetGridColDef(panelInfo, coldef) {
        const index = gridIndex(panelInfo);
        if (index === -1 || isEmpty(gridcolRefs.current[index])) return;
        gridcolRefs.current[index].current = coldef;
    }

    function GridApi(panelInfo) {
        const index = gridIndex(panelInfo);
        if (index === -1 || isEmpty(gridapiRefs.current[index])) return null;
        return gridapiRefs.current[index].current;
    }

    function GridColApi(panelInfo) {
        const index = gridIndex(panelInfo);
        if (index === -1 || isEmpty(gridcolapiRefs.current[index])) return null;
        return gridcolapiRefs.current[index].current;
    }

    function numberValue(value) {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    }

    function roundAmount(value) {
        return Math.round((numberValue(value) + Number.EPSILON) * 100) / 100;
    }

    function columnIdByName(type, name) {
        if (isEmpty(columninfo)) return '';
        const target = columninfo.find(item =>
            item.type === type && String(item.columnnm ?? '').trim() === name
        );
        return isEmpty(target) ? '' : target.columnid;
    }

    function isInvoiceDetailPanel(panelInfo) {
        if (isEmpty(panelInfo) || String(panelInfo.id).startsWith('T')) return false;
        return !isEmpty(columninfo) && columninfo.some(item =>
            item.type === panelInfo.type && item.columnid === 'IVM_HACHUSU'
        );
    }

    function setInvoiceTotalData(panelInfo, total) {
        const totalType = tabletype('T' + panelInfo.id);
        if (isEmpty(totalType)) return;

        const totalPanel = { id: 'T' + panelInfo.id, type: totalType };
        const currentRows = GridData(totalPanel);
        const totalRow = !isEmpty(currentRows) && !isEmpty(currentRows[0])
            ? { ...currentRows[0] }
            : { rowid: 'TOTAL', grip: '計' };
        const values = {
            '発注数合計': total.orderQuantity,
            '納品数合計': total.deliveryQuantity,
            '残数合計': total.remainingQuantity,
            '金額合計': total.amount,
        };

        Object.entries(values).forEach(([name, value]) => {
            const columnId = columnIdByName(totalType, name);
            if (!isEmpty(columnId)) totalRow[columnId] = value;
        });
        SetGridData(totalPanel, [totalRow]);

        const totalApi = GridApi(totalPanel);
        const totalNode = isEmpty(totalApi) ? null : totalApi.getRowNode('TOTAL');
        if (!isEmpty(totalNode)) {
            Object.entries(values).forEach(([name, value]) => {
                const columnId = columnIdByName(totalType, name);
                if (!isEmpty(columnId)) totalNode.setDataValue(columnId, value);
            });
        }
    }

    function recalculateInvoiceDetail(panelInfo, changedData) {
        if (!isInvoiceDetailPanel(panelInfo)) return;

        const rows = Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : [];
        const remainingColumnId = columnIdByName(panelInfo.type, '残数');
        const total = {
            orderQuantity: 0,
            deliveryQuantity: 0,
            remainingQuantity: 0,
            amount: 0,
        };

        if (!isEmpty(changedData)) {
            const changedRow = rows.find(row => row.rowid === changedData.rowid);
            if (!isEmpty(changedRow)) Object.assign(changedRow, changedData);
        }

        rows.forEach(row => {
            const orderQuantity = numberValue(row.IVM_HACHUSU);
            const deliveryQuantity = numberValue(row.IVM_NOHINSU);
            const remainingQuantity = orderQuantity - deliveryQuantity;
            const amount = roundAmount(deliveryQuantity * numberValue(row.IVM_TANKA));

            if (!isEmpty(remainingColumnId)) row[remainingColumnId] = remainingQuantity;
            row.IVM_KINGAKU = amount;
            total.orderQuantity += orderQuantity;
            total.deliveryQuantity += deliveryQuantity;
            total.remainingQuantity += remainingQuantity;
            total.amount = roundAmount(total.amount + amount);
        });

        SetGridData(panelInfo, rows);
        setInvoiceTotalData(panelInfo, total);

        const detailApi = GridApi(panelInfo);
        if (!isEmpty(detailApi)) detailApi.refreshCells({ force: true });
    }

    function invoiceDetailChanged(params, panelInfo) {
        storeRowData(panelInfo);
        recalculateInvoiceDetail(panelInfo, params?.data);
        fnc.current.rerenderGrid(fnc.current.GridID(panelInfo));

        const totalType = tabletype('T' + panelInfo.id);
        if (!isEmpty(totalType)) {
            fnc.current.rerenderGrid(fnc.current.GridID({ id: 'T' + panelInfo.id, type: totalType }));
        }
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;

        fnc.current.postaxios('common/GetListTabs', { panels: panelsdef, controller: controller, subkey: subkey }, {
            onSuccess: function (data) {
                const entryPanels = data.panels.filter(panelInfo => panelInfo.id !== 'pic' && panelInfo.id !== 'file');
                setpanel(entryPanels);
                baseRef.current?.hideMenucmd([
                    { status: 'UPDATE', cmd: '削除' },
                    { status: 'ENTRY FORM', cmd: '削除' },
                ]);
                dispatch(setentrypanel({
                    layouts: data.layouts,
                    prelayout: data.prelayout,
                    initlayout: data.initlayout.length === 0 ? ' ' : data.initlayout,
                    fitColumn: data.fitColumn,
                }));
                setcolumninfo(data.colinfo);
                setcolumns(data.columns);
                setprimarykeys(data.primarykeys ?? []);

                const fields = data.colinfo.filter(field => field.logpid === G_id.BASE);
                settextfieldsall(fields);
                settextfields(data.columns.filter(field => field.logpid === G_id.BASE));
                fnc.current.initMaster(data.master);

                let index = 0;
                const nextGridList = [];
                gridapiRefs.current = [];
                gridcolapiRefs.current = [];
                griddataRefs.current = [];
                gridcolRefs.current = [];

                entryPanels.filter(panelInfo => panelInfo.grid).forEach(panelInfo => {
                    gridapiRefs.current[index] = createRef();
                    gridcolapiRefs.current[index] = createRef();
                    griddataRefs.current[index] = createRef();
                    gridcolRefs.current[index] = createRef();
                    griddataRefs.current[index].current = [];
                    nextGridList.push({ id: panelInfo.id, type: panelInfo.type, index: index });
                    index++;

                    const totalColumn = data.colinfo.find(field => field.logpid === 'T' + panelInfo.id);
                    if (!isEmpty(totalColumn)) {
                        gridapiRefs.current[index] = createRef();
                        gridcolapiRefs.current[index] = createRef();
                        griddataRefs.current[index] = createRef();
                        gridcolRefs.current[index] = createRef();
                        griddataRefs.current[index].current = [];
                        nextGridList.push({ id: 'T' + panelInfo.id, type: totalColumn.type, index: index });
                        index++;
                    }
                });

                dispatch(setgridlist(nextGridList));

                // 作業・進捗管理画面から渡された遷移情報を、一覧取得または Grid 描画完了後の受入処理で使用する。
                let state = props.location.state;
                if (isEmpty(state) && !isEmpty(window.history.state) && 'status' in window.history.state) {
                    state = window.history.state;
                }
                const storageKey = new URLSearchParams(search).get('key');
                if (isEmpty(state) && !isEmpty(storageKey)) {
                    state = Loadstorage(storageKey)?.state;
                }
                locationstate.current = state;
                transinfo.current = null;
                if (!isEmpty(state) && 'code' in state) {
                    transinfo.current = Object.assign({}, state);
                    if (state.status === 'LIST') {
                        document.title += ' <作業・進捗管理>';
                        baseRef.current?.ListExecute(true);
                    } else if (isEmpty(state.code)) {
                        entrydataRef.current = initializedata(fields, staff);
                        dispatch(changestatus('NEW FORM'));
                    } else {
                        dispatch(changestatus('ENTRY FORM'));
                    }
                }
                fnc.current.wait(false);
            },
        });
    }, [search, corpkey, account, controller, subkey, dispatch, props.location.state, staff]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf('LOCK2') !== -1);
        setsectionclose(menuinfo.ctrls.indexOf('SECCLOSE') !== -1);
    }, [menuinfo]);

    function clearform() {
        entrydataRef.current = initializedata(textfieldsall, staff);
        gridlist.forEach(panelInfo => SetGridData(panelInfo, null));
        fnc.current.modify(false);
        rerender();
    }

    function Show(data) {
        if (isEmpty(columninfo)) return false;

        if (data === undefined) {
            if (isEmpty(edittingcode)) {
                rerender();
            } else {
                LoadData(edittingcode);
            }
            return true;
        }

        clearform();
        const rowData = data === null ? {} : data;
        setglobaldata('entryrowdata', rowData);
        entrydataRef.current = { ...entrydataRef.current, ...rowData };

        let code = buildInvoiceIdentity(rowData);
        if (isEmpty(code)) {
            for (let i = 0; i < primarykeys.length; i++) {
                if (!isEmpty(rowData[primarykeys[i]])) {
                    code = rowData[primarykeys[i]];
                    break;
                }
            }
        }
        setedittingcode(code);
        if (isEmpty(code)) {
            rerender();
        } else {
            LoadData(code);
        }
        return true;
    }

    function MenuAction(action, finallycallback, option, gridApi) {
        if (action === 'save') {
            Save(finallycallback);
            return;
        }
        if (action === 'clear') {
            clearform();
            return;
        }
        if (action === 'invoice-confirm') {
            if (String(entrydataRef.current?.IVD_FIXFLG ?? '') === '1') {
                fnc.current.warnmsg('既にInvoice確定済みです。');
                return;
            }
            ConfirmEntryAction('Invoiceを確定します。よろしいですか？', entryMenuActionUrl.invoiceFix, finallycallback);
            return;
        }
        if (action === 'bl-confirm') {
            ConfirmEntryAction('B/L予定を確定します。よろしいですか？', entryMenuActionUrl.blFix, finallycallback);
            return;
        }
        if (action === 'invoice-cover') {
            PrintInvoice(entryMenuActionUrl.invoiceCover, option, gridApi);
            return;
        }
        if (action !== 'linkfield' || isEmpty(finallycallback)) return;

        const field = textfields.find(item =>
            item.columnid === finallycallback.field && (isEmpty(finallycallback.type) || item.type === finallycallback.type)
        );
        if (isEmpty(field)) return;

        if (field.logpid === G_id.BASE) {
            const element = document.getElementById(finallycallback.field + '_' + field.type);
            if (!isEmpty(element)) {
                element.focus();
                element.select();
            }
            Jump(G_id.BASE, field.type);
            return;
        }

        Jump(field.logpid, field.type);
        if (!isEmpty(AGRef.current)) {
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: field.logpid, type: field.type }));
        }
    }

    function ConfirmEntryAction(message, url, finallycallback) {
        fnc.current.confmsg(message, () => {
            const paramdata = BuildEntryParamData(false);
            fnc.current.postaxios(url, paramdata, {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        fnc.current.success();
                        if (!isEmpty(finallycallback) && !isEmpty(data.data)) {
                            data.data.rowid = Getrowid();
                            finallycallback(data.data);
                        }
                        LoadData(data.request || edittingcode);
                    } else {
                        fnc.current.showwarndescription(
                            data.warning.length + '件の制約違反により確定できませんでした。',
                            data.warning
                        );
                    }
                    fnc.current.wait(false);
                },
                errmsg: '確定処理に失敗しました',
            });
        });
    }

    function PrintInvoice(url, option, gridApi) {
        let rows = [];
        if (formstatus === 'ENTRY FORM' && !isEmpty(entrydataRef.current)) {
            rows = [entrydataRef.current];
        } else if (Array.isArray(option)) {
            rows = option;
        } else if (!isEmpty(gridApi)) {
            rows = gridApi.getSelectedRows();
        }

        if (rows.length === 0) {
            fnc.current.warnmsg('発行対象のデータを選択してください。');
            return;
        }

        if (rows.length !== 1) {
            fnc.current.warnmsg('発行対象は1件だけ選択してください。');
            return;
        }

        const row = rows[0];
        const invoiceKanriNo = !isEmpty(row.IVD_INVOICEKANRINO)
            ? row.IVD_INVOICEKANRINO
            : String(row.IVD_INVOICECD ?? '') + String(row.IVD_INVOICENO ?? '');
        const invoiceKanriEda = !isEmpty(row.IVD_INVOICEKANRIEDA)
            ? row.IVD_INVOICEKANRIEDA
            : row.IVD_INVOICEEDA;
        const invoiceDate = !isEmpty(row.IVD_INVOICEDATE)
            ? row.IVD_INVOICEDATE
            : row.IVD_INVOICEYMD;

        if (isEmpty(invoiceKanriNo) || isEmpty(invoiceKanriEda) || isEmpty(invoiceDate)) {
            fnc.current.warnmsg('Invoice管理No.、Invoice管理枝番、Invoice Dateを取得できませんでした。');
            return;
        }

        fnc.current.postaxios(url, {
            invoiceKanriNo: invoiceKanriNo,
            invoiceKanriEda: invoiceKanriEda,
            invoiceDate: invoiceDate,
            invoiceSyubetu: '2',
        }, {
            onSuccess: function (data) {
                fnc.current.filedownload('excel/ExcelDownload', {
                    excelfile: data.returnData.filename,
                    dnfile: data.returnData.dnfile,
                });
                fnc.current.wait(false);
            },
            errmsg: '帳票の発行に失敗しました',
        });
    }

    function BuildEntryParamData(noconfirm) {
        storeRowData();
        const detail = {};
        gridlist.forEach(panelInfo => {
            const isDetailPanel = panel.some(item =>
                item.grid && item.id === panelInfo.id && item.type === panelInfo.type
            );
            if (isDetailPanel) detail[panelInfo.type] = GridData(panelInfo);
        });

        return {
            controller: formid,
            data: entrydataRef.current,
            detail: detail,
            colinfo: columninfo,
            code: edittingcode,
            noconfirm: noconfirm,
        };
    }

    function Save(finallycallback, noconfirm) {
        const paramdata = BuildEntryParamData(noconfirm);
        const saveUrl = formstatus === 'ENTRY FORM' ? 'InvoiceIn/UpdateEntry' : 'InvoiceIn/InsertEntry';
        fnc.current.postaxios(saveUrl, paramdata, {
            onSuccess: function (data) {
                if (data.warning.length === 0) {
                    fnc.current.modify(false);
                    const code = data.request || buildInvoiceIdentity(entrydataRef.current) || edittingcode;

                    if (formstatus !== 'ENTRY FORM') {
                        const invoiceKeys = parseInvoiceIdentity(code);
                        entrydataRef.current = { ...entrydataRef.current, ...invoiceKeys };
                        setedittingcode(code);
                        dispatch(changestatus('ENTRY FORM'));
                    }

                    fnc.current.success();
                    if (formstatus === 'ENTRY FORM' && !isEmpty(finallycallback) && !isEmpty(data.data)) {
                        data.data.rowid = Getrowid();
                        finallycallback(data.data);
                    }
                    LoadData(code);
                } else if (isEnabled(data.confirm)) {
                    const messages = ['内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください', '　'];
                    data.warning.forEach(warning => messages.push('・' + warning.message));
                    fnc.current.confmsg(messages, () => Save(finallycallback, true));
                } else {
                    fnc.current.showwarndescription(
                        data.warning.length + '件の制約違反により登録できませんでした。',
                        data.warning
                    );
                }
                fnc.current.wait(false);
            },
            errmsg: '登録に失敗しました',
        });
    }

    function Getrowid() {
        const data = getglobaldata('entryrowdata');
        return isEmpty(data) ? '' : data.rowid;
    }

    function LoadData(code) {
        if (isEmpty(code)) return;

        const selectedRow = getglobaldata('entryrowdata') || {};
        const parsedKeys = parseInvoiceIdentity(code);
        const invoiceKeys = invoiceKeyFields.reduce((result, field) => {
            result[field] = invoiceKeyValue(
                parsedKeys,
                field,
                invoiceKeyValue(selectedRow, field, invoiceKeyValue(entrydataRef.current, field))
            );
            return result;
        }, {});
        invoiceKeys.IVD_INVOICEKBN = invoiceKeys.IVD_INVOICEKBN || '1';
        invoiceKeys.IVD_INVOICESUB = invoiceKeys.IVD_INVOICESUB || '00000';
        const requestCode = invoiceKeys.IVD_INVOICECD || code;

        fnc.current.postaxios('InvoiceIn/GetData', {
            code: requestCode,
            others: invoiceKeys,
            colinfo: columninfo,
            controller: controller,
        }, {
            onSuccess: function (data) {
                fnc.current.margeMaster(data.master);
                const blData = data.detail?.['102']?.[0] ?? {};
                entrydataRef.current = {
                    ...data.data,
                    ...blData,
                };

                gridlist.forEach(panelInfo => {
                    const rows = isEmpty(data.detail) ? [] : data.detail[panelInfo.type];
                    SetGridData(panelInfo, isEmpty(rows) ? null : rows);
                });
                gridlist.forEach(panelInfo => recalculateInvoiceDetail(panelInfo));

                setedittingcode(buildInvoiceIdentity(entrydataRef.current) || code);
                fnc.current.modify(false);
                rerender();
                fnc.current.wait(false);
            },
            errmsg: 'データの取得に失敗しました',
        });
    }

    // 別画面からの遷移情報は、全明細 Grid の API が使用可能になってから一度だけ反映する。
    function TryCallTransition() {
        if (isEmpty(locationstate.current)) return;
        if (locationstate.current.status === 'LIST') return;

        for (let i = 0; i < gridlist.length; i++) {
            if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
            if (isEmpty(GridApi(gridlist[i]))) return;
        }

        const state = locationstate.current;
        locationstate.current = null;
        if (!isEmpty(state.code)) {
            setedittingcode(state.code);
            LoadData(state.code);
            return;
        }

        if (!isEmpty(state.acceptinfo)) {
            AcceptAction(state);
            return;
        }

        const acceptNo = !isEmpty(state.acceptno) ? state.acceptno : state.keys;
        if (isEmpty(acceptNo)) {
            dispatch(changestatus('VIEW'));
            fnc.current.warnmsg('発注番号が指定されていません。');
            return;
        }
        AcceptOrder(acceptNo);
    }

    // 作業・進捗管理から受け取った発注・加工指示・納品先情報を、Invoice の新規初期値へ変換する。
    function AcceptAction(state) {
        fnc.current.postaxios('InvoiceIn/GetAccept', {
            type: state.accepttype,
            colinfo: columninfo,
            addinfo: [state.acceptinfo],
            controller: controller,
        }, {
            onSuccess: function (data) {
                ApplyAcceptData(data);
            },
            errmsg: '発注情報の取得に失敗しました',
        });
    }

    // 発注番号を W_SSH の初期値へ変換し、NEW FORM に設定する。
    function AcceptOrder(value) {
        const orderNos = (Array.isArray(value) ? value : [value])
            .map(item => String(item ?? '').trim())
            .filter(item => item !== '');
        if (orderNos.length === 0) {
            dispatch(changestatus('VIEW'));
            fnc.current.warnmsg('発注番号が指定されていません。');
            return;
        }

        fnc.current.postaxios('InvoiceIn/GetAccept', {
            keys: orderNos,
            colinfo: columninfo,
            controller: controller,
        }, {
            onSuccess: function (data) {
                ApplyAcceptData(data);
            },
            errmsg: '発注情報の取得に失敗しました',
        });
    }

    function ApplyAcceptData(data) {
        fnc.current.margeMaster(data.master);
        entrydataRef.current = {
            ...initializedata(textfieldsall, staff),
            ...data.data,
        };

        gridlist.forEach(panelInfo => {
            const rows = isEmpty(data.detail) ? [] : data.detail[panelInfo.type];
            SetGridData(panelInfo, isEmpty(rows) ? null : rows);
        });
        gridlist.forEach(panelInfo => recalculateInvoiceDetail(panelInfo));

        setedittingcode('');
        fnc.current.modify(false);
        rerender();
        fnc.current.wait(false);
    }

    // 作業・進捗管理から LIST 起動された場合、対象の発注情報だけを即時表示する。
    function QueryGetlist(param) {
        if (transinfo.current?.accepttype !== 'WorkProgMgr') return;
        if (transinfo.current.status !== 'LIST') return;

        param.notshow = false;
        param.code = transinfo.current.keys;
        param.request = transinfo.current.accepttype;
    }

    function HandleEntryStatusAction(action) {
        if (action === 'CANCEL') {
            dispatch(changestatus('VIEW'));
            return;
        }
    }

    function ValueChanged(id) {
        if (isEmpty(columninfo)) return;
        const column = columninfo.find(item => item.columnid === id);
        if (!isEmpty(column) && column.extriggerref) {
            dispatch(entrytriggercall(id));
        }
    }

    function setGridApiAndTryTransition(params, panelInfo) {
        const index = gridIndex(panelInfo);
        if (index === -1) return;
        gridapiRefs.current[index].current = params.api;
        gridcolapiRefs.current[index].current = params.api;
        TryCallTransition();
    }

    function onFirstDataRendered(params, panelInfo) {
        setGridApiAndTryTransition(params, panelInfo);
    }

    function storeRowData(panelInfo) {
        if (isEmpty(AGRef.current)) return;
        if (panelInfo === undefined) {
            gridlist.forEach(item => {
                const api = GridApi(item);
                if (!isEmpty(api)) SetGridData(item, AGRef.current.GetDatasource(api));
            });
            return;
        }

        const api = GridApi(panelInfo);
        if (!isEmpty(api)) SetGridData(panelInfo, AGRef.current.GetDatasource(api));
    }

    function tabletype(id, type) {
        if (!isEmpty(type)) return type;
        if (id.substring(0, 1) === 'T') {
            if (isEmpty(columninfo)) return '';
            const column = columninfo.find(item => item.logpid === id);
            return isEmpty(column) ? '' : column.type;
        }
        const panelInfo = panel.find(item => item.id === id);
        return isEmpty(panelInfo) ? '' : panelInfo.type;
    }

    function SetLayout(newColumns, type) {
        const nextFields = DeepCopy(textfields.filter(field => field.type !== type));
        newColumns.forEach(columnId => {
            const field = textfieldsall.find(item => item.columnid === columnId);
            if (!isEmpty(field)) nextFields.push(field);
        });
        settextfields(nextFields);
    }

    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }

    function showpanel(id, type, show) {
        const nextPanels = DeepCopy(panel);
        const target = nextPanels.find(item => item.id === id && item.type === type);
        if (isEmpty(target)) return;
        target.hide = !show;
        setpanel(nextPanels);
    }

    function SaveLayout(layoutid) {
        const coldef = [];
        let baseSet = false;

        panel.forEach(panelInfo => {
            if (panelInfo.id === G_id.BASE) {
                if (baseSet) return;
                textfields.filter(field => !field.hide).forEach(field => {
                    coldef.push({
                        headerName: field.columnnm,
                        table: field.table,
                        field: field.columnid,
                        width: field.width,
                        type: field.type,
                    });
                });
                baseSet = true;
                return;
            }

            if (!panelInfo.grid) return;
            const shownColumns = AGRef.current.GetshownColDef(GridColApi(panelInfo));
            shownColumns.forEach(column => {
                const nextColumn = DeepCopy(column);
                nextColumn.type = tabletype(panelInfo.id, panelInfo.type);
                coldef.push(nextColumn);
            });
        });

        fnc.current.postaxios('common/SaveLayout', {
            controller: controller,
            subkey: subkey,
            code: layoutid,
            coldef: coldef,
            panels: panel,
        }, {
            onSuccess: function () {
                dispatch(addentrylayout({ value: layoutid, label: layoutid }));
                fnc.current.success();
                fnc.current.wait(false);
            },
        });
    }

    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout', {
            controller: controller,
            subkey: subkey,
            code: layoutid,
        }, {
            onSuccess: function (data) {
                dispatch(setentrylayout(mainlayout.filter(layout => layout.value !== layoutid)));
                if (data.request !== maininitlayout) {
                    dispatch(setentrystartup({
                        prelayout: mainprelayout,
                        initlayout: ' ',
                        fitColumn: false,
                    }));
                }
                fnc.current.success();
                fnc.current.wait(false);
            },
        });
    }

    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout', {
            controller: controller,
            subkey: subkey,
            code: layoutid,
        }, {
            onSuccess: function (data) {
                gridlist.forEach(panelInfo => {
                    const coldef = AGRef.current.createColDef(
                        columninfo.filter(field => field.type === panelInfo.type),
                        data.columns.filter(field => field.type === panelInfo.type),
                        false
                    );
                    if (!isEmpty(coldef)) SetGridColDef(panelInfo, coldef);
                });
                setpanel(data.panels);
                settextfields(data.columns.filter(field => field.logpid === G_id.BASE));
                setcolumns(data.columns);
                fnc.current.wait(false);
            },
        });
    }

    function Jump(id, type) {
        let panelId = 'basepanel' + type;
        if (isEmpty(type)) type = tabletype(id);
        if (panel.some(item => item.id === id && item.type === type && item.grid)) {
            panelId = fnc.current.GridID({ id: id, type: type });
        }
        const element = document.getElementById(panelId);
        if (isEmpty(element) || isEmpty(EntrybodyRef.current)) return;
        EntrybodyRef.current.scrollTop = element.offsetTop - 50;
    }

    function EmptyPanel(id, type) {
        try {
            if (!panel.some(item => item.id === id)) return true;
            if (!isEmpty(type) && !panel.some(item => item.id === id && item.type === type)) return true;
            if (id === G_id.BASE) return isEmpty(textfields.find(field => field.type === type));
            const targetType = tabletype(id, type);
            return !columns.some(column => column.type === targetType);
        } catch {
            return true;
        }
    }

    function panelhidden(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        if (EmptyPanel(panelInfo.id, panelInfo.type)) return true;
        return panelInfo.hide;
    }

    function InvoiceSupplierCodeLabelStyle(panelInfo) {
        const fields = textfields.filter(field => field.type === panelInfo.type);
        const index = fields.findIndex(field =>
            String(field.columnid).toUpperCase() === 'IVD_INVOICECD'
        );
        if (index === -1) return null;

        return (
            <style>{`
                #basepanel${panelInfo.type} > div > div:nth-child(${index + 1}) > .fieldlabel {
                    font-size: 6px !important;
                    white-space: nowrap;
                    line-height: 1;
                }
            `}</style>
        );
    }

    function Contents({ panel: panelInfo }) {
        if (panelInfo.id === G_id.BASE) {
            return (
                <div id={'basepanel' + panelInfo.type}>
                    {InvoiceSupplierCodeLabelStyle(panelInfo)}
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={panelInfo}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }

        if (panelInfo.id === G_id.NB) {
            const definition = isEmpty(columninfo) ? null : columninfo.find(item => item.type === panelInfo.type);
            return (
                <EntryRemarks
                    id={'remarkspanel' + panelInfo.type}
                    def={definition}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            );
        }

        if (!panelInfo.grid) return null;
        const index = gridIndex(panelInfo);
        if (index === -1) return null;
        const totalType = tabletype('T' + panelInfo.id);
        const totalIndex = isEmpty(totalType) ? -1 : gridIndex({ id: 'T' + panelInfo.id, type: totalType });

        return (
            <React.Fragment>
                <EntryGridAr
                    id={fnc.current.GridID(panelInfo)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[index]}
                    columnRef={gridcolRefs.current[index]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onGridReady={params => setGridApiAndTryTransition(params, panelInfo)}
                    onFirstDataRendered={params => onFirstDataRendered(params, panelInfo)}
                    ValueChanged={params => invoiceDetailChanged(params, panelInfo)}
                    RemoveRow={params => invoiceDetailChanged(params, panelInfo)}
                    formid={formid}
                    panel={panelInfo}
                />
                {totalIndex === -1 ? null :
                    <EntryGridAr
                        id={fnc.current.GridID('T' + panelInfo.id)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[totalIndex]}
                        columnRef={gridcolRefs.current[totalIndex]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onGridReady={params => setGridApiAndTryTransition(params, {
                            id: 'T' + panelInfo.id,
                            type: totalType,
                        })}
                        onFirstDataRendered={params => onFirstDataRendered(params, {
                            id: 'T' + panelInfo.id,
                            type: totalType,
                        })}
                        formid={formid}
                        panel={panelInfo}
                        total={true}
                        totaltype={totalType}
                    />
                }
            </React.Fragment>
        );
    }

    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        const visiblePanels = panel.filter(item => !panelhidden(item));
        const oldPanelIndex = panel.findIndex(item => item.id === visiblePanels[oldIndex].id && item.type === visiblePanels[oldIndex].type);
        const newPanelIndex = panel.findIndex(item => item.id === visiblePanels[newIndex].id && item.type === visiblePanels[newIndex].type);
        setpanel(arrayMove(panel, oldPanelIndex, newPanelIndex));
    };

    const SortablePanelItem = SortableElement(({ panelInfo }) => (
        <ListItem className="minwidth0">
            <Chip label={panelInfo.name} title={panelInfo.name} size="small" onClick={() => Jump(panelInfo.id, panelInfo.type)} />
        </ListItem>
    ));

    const SortablePanelSelector = SortableContainer(({ items }) => (
        <ul style={{ display: 'flex' }}>
            {items.filter(item => !panelhidden(item)).map((item, index) => (
                <SortablePanelItem key={item.id + '_' + item.type} index={index} panelInfo={item} />
            ))}
        </ul>
    ));

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((panelInfo, index) => (
                    <Box
                        key={panelInfo.id + '_' + panelInfo.type + '_' + index}
                        display={panelhidden(panelInfo) ? 'none' : 'flex'}
                        justifyContent="space-around"
                        alignItems="center"
                        padding="5px"
                    >
                        <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                            <div style={{ position: 'relative', marginBottom: 5 }}>
                                {panelInfo.name} - <span style={{ fontStyle: 'oblique' }}>{panelInfo.name2}</span>
                                {panelInfo.id !== G_id.BASE || layoutlock ? null :
                                    <div style={{ position: 'absolute', right: 40, top: -3 }} title="レイアウト設定">
                                        <IconButton size="small" onClick={() => SetBaseField(panelInfo.type)}>
                                            <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                        </IconButton>
                                    </div>
                                }
                                {layoutlock || sectionclose ? null :
                                    <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                        <IconButton size="small" onClick={() => showpanel(panelInfo.id, panelInfo.type, false)}>
                                            <Icon style={{ fontSize: 16 }}>close</Icon>
                                        </IconButton>
                                    </div>
                                }
                            </div>
                            <Contents panel={panelInfo} />
                        </Paper>
                    </Box>
                ))}
            </div>
        );
    }

    const entryStatusOptions = formstatus === 'ENTRY FORM' ? ['CANCEL'] : undefined;
    const entryVisible = formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM';

    return (
        <div>
            <ComFunc ref={fnc} />
            <AGFunc ref={AGRef} />
            <MasterBase
                ref={baseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                entryform={true}
                entrycallback={MenuAction}
                primarykey={primarykeys}
                show={Show}
                querygetlist={QueryGetlist}
                suppressaction={suppressaction}
                entrystatusoptions={entryStatusOptions}
                entrystatusaction={entryStatusOptions === undefined ? undefined : HandleEntryStatusAction}
            >
                <EntryForm />
            </MasterBase>

            <EntryLayout columninfo={textfieldsall} textfields={textfields} onAppry={SetLayout} />

            {entryVisible ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title="レイアウト設定">
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            component="ul"
                            elevation={0}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                margin: 0,
                                padding: 4,
                                backgroundColor: 'transparent',
                                width: 'auto',
                            }}
                        >
                            <SortablePanelSelector axis="x" items={panel} onSortEnd={onPanelSortEnd} distance={2} />
                        </Paper>
                    </div>
                </div>
                : null}

            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
